<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_499')}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('scope.text_500')" :count="params.data.length" :action="params.action" />
      <dialog-table :data="params.data" :columns="columns" />
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_495')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.agent_level" :placeholder="$t('scope.text_501')">
            <a-select-option v-for="item in levels" :key="item.id" :value="item.id">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SetAgentLevelDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        agent_level: [
          'agent_level',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      levels: [
        {
          name: this.$t('scope.text_496'),
          id: 0,
        },
        {
          name: this.$t('scope.text_497'),
          id: 1,
        },
      ],
      columns: [
        {
          field: 'enterprise_name',
          title: this.$t('scope.text_318'),
          width: 200,
          slots: {
            default: ({ row }, h) => {
              const ret = [
                <side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.enterprise_name || '-' }</side-page-trigger>,
              ]
              return ret
            },
          },
        },
        {
          field: 'name',
          title: this.$t('scope.text_322'),
        },
        {
          field: 'mobile',
          title: this.$t('scope.text_494'),
        },
      ],
    }
  },
  methods: {
    doSet (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'customer-level',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doSet(values)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
